import { takeEvery, put, take } from "redux-saga/effects";//header
//header
import {GET_HISTORY_DATA, GET_USER_INFO_DATA} from "../../common/User/store/actionTypes";
import {setHistoryData, setUserInfoData, setUserInfoMsgData} from "../../common/User/store/actionCreators";
import $axios from "../../request";
import { Toast} from 'antd-mobile';
import {setHeaderData} from "../../common/Header/store/actionCreators";

function* mySaga() {
    yield takeEvery(GET_USER_INFO_DATA, _getUserInfoData);
    yield takeEvery(GET_HISTORY_DATA, _getHistoryData)
}

function* _getHistoryData(e) {
    if (e.data) {
        yield put(setHistoryData(e.data))
    }
}

function* _getUserInfoData() {
    let url = '/sys/personnel/info';
    let data = new FormData();

    let res = $axios.postRequest(url, data)
    let object ;

    let errorMessage;
    yield res.then(response => {
        console.log(url, response);
        object = response?.data;
        errorMessage = response.data && (response.data.ErrMsg || response.Message) || response.errorMessage
    })
    console.log("errorMessage", errorMessage);
    if(errorMessage ==='效验登录用户信息失败' || errorMessage === '用户已在其它位置登陆！'|| errorMessage === '获取用户信息失败'){
        if(getCurrentEnvironment()){
            window.location.href= encodeURI("/goodNetizen/wxLogin/toAuth?scope=snsapi_userinfo&from=https://lottery.jlszhgh.com/wxLogin");
        }else{
            yield put(setUserInfoMsgData(errorMessage))
        }
    }else{
        yield put(setUserInfoMsgData(errorMessage))
    }
    yield put(setUserInfoData(object?.user))


}
function getCurrentEnvironment() {
    //判断当前页面的运行环境（微信/其他）
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("微信环境中");
        return true
    } else {
        console.log("其他环境中（例如浏览器等等）");
        return false
    }
}


export default mySaga
